import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import {
  resetBasicPolicyDetails,
  resetHomeAddress,
  resetPersonalDetails,
  resetPolicy,
  resetProductSelection,
  resetUnitConstructionAndDetails,
} from "@covertree/new-business-redux";

import { client } from "@apolloClient/client";
import { useAppDispatch } from "@redux/hooks";

/**
 * Provides function to reset new policy data and navigate to a specific path.
 *
 * @return function getting optional string param as path
 */
export const useResetNewPolicy = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(
    (path?: string, withProduct?: boolean) => {
      dispatch(resetPolicy());
      dispatch(resetHomeAddress());
      if (withProduct) dispatch(resetProductSelection());
      dispatch(resetBasicPolicyDetails());
      dispatch(resetUnitConstructionAndDetails());
      dispatch(resetPersonalDetails());
      client.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "getExtraCoveragePrices",
      });
      client.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "getQuoteDocuments",
      });
      client.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "fetchUWDecisionAndGeneratePaymentPlans",
      });
      client.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "getPricedCustomizedPolicy",
      });
      if (path) {
        navigate(path);
      }
    },
    [dispatch, navigate]
  );
};
